import { render, staticRenderFns } from "./mo-stacked-accordion.html?vue&type=template&id=af3bd916&scoped=true&external"
import script from "./mo-stacked-accordion.ts?vue&type=script&lang=ts&external"
export * from "./mo-stacked-accordion.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-stacked-accordion.vue?vue&type=style&index=0&id=af3bd916&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3bd916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af3bd916')) {
      api.createRecord('af3bd916', component.options)
    } else {
      api.reload('af3bd916', component.options)
    }
    module.hot.accept("./mo-stacked-accordion.html?vue&type=template&id=af3bd916&scoped=true&external", function () {
      api.rerender('af3bd916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-stacked-accordion/mo-stacked-accordion.vue"
export default component.exports